/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentForReport,
  OrderPaymentForReportOptional,
  OrderPaymentForReportMetaI,
  OrderPaymentForReportTrackedI,
} from "./order-payment-for-report";
import {
  OrderPaymentForReportTracked,
  OrderPaymentForReportMeta,
} from "./order-payment-for-report";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentReportDTO,
  PaymentReportDTOOptional,
  PaymentReportDTOMetaI,
  PaymentReportDTOTrackedI,
} from "./payment-report-dto";
import {
  PaymentReportDTOTracked,
  PaymentReportDTOMeta,
} from "./payment-report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportDTO,
  ReportDTOOptional,
  ReportDTOMetaI,
  ReportDTOTrackedI,
} from "./report-dto";
import { ReportDTOTracked, ReportDTOMeta } from "./report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";

/**
 *
 * @export
 * @interface PaymentReportsDTO
 */
export interface PaymentReportsDTOOptional extends OrderPaymentForReportOptional {
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportsDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportsDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentReportsDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentReportsDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof PaymentReportsDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof PaymentReportsDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof PaymentReportsDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof PaymentReportsDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof PaymentReportsDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentReportsDTO
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentToRefundCents?: number;
  /**
   *
   * @type {Array<PaymentReportDTO>}
   * @memberof PaymentReportsDTO
   */
  paymentReports?: PaymentReportDTOOptional[];
}

export interface PaymentReportsDTO
  extends PaymentReportsDTOOptional, OrderPaymentForReport, ReportDTO {
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportsDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportsDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentReportsDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof PaymentReportsDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof PaymentReportsDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof PaymentReportsDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof PaymentReportsDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof PaymentReportsDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof PaymentReportsDTO
   */
  typeCounts?: ReportTypeCountDTO[];
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentReportsDTO
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentToRefundCents?: number;
  /**
   *
   * @type {Array<PaymentReportDTO>}
   * @memberof PaymentReportsDTO
   */
  paymentReports: PaymentReportDTO[];
}

export interface PaymentReportsDTOTrackedI extends OrderPaymentForReportOptional {
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportsDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportsDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportsDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportsDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof PaymentReportsDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof PaymentReportsDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof PaymentReportsDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof PaymentReportsDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof PaymentReportsDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentServiceChangeCents?: number;
  paymentServiceChangeCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentCapturableCents?: number;
  paymentCapturableCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportsDTO
   */
  paymentCapturableDate?: Date;
  paymentCapturableDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentPaidCents?: number;
  paymentPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentTotalCents?: number;
  paymentTotalCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentRefundedCents?: number;
  paymentRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportsDTO
   */
  paymentToRefundCents?: number;
  paymentToRefundCentsIsSet: boolean;
  /**
   *
   * @type {Array<PaymentReportDTO>}
   * @memberof PaymentReportsDTO
   */
  paymentReports?: PaymentReportDTOTrackedI[];
  paymentReportsIsSet: boolean;
}

transformDatesMap.set("PaymentReportsDTO", function (model: PaymentReportsDTO) {
  const transformDateschildReports = transformDatesMap.get("ReportDTO");
  if (transformDateschildReports) {
    model.childReports?.forEach((sub) => {
      transformDateschildReports(sub);
    });
  }
  const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
  if (transformDatesmeta) {
    model.meta?.forEach((sub) => {
      transformDatesmeta(sub);
    });
  }
  const transformDatestypeCounts = transformDatesMap.get("ReportTypeCountDTO");
  if (transformDatestypeCounts) {
    model.typeCounts?.forEach((sub) => {
      transformDatestypeCounts(sub);
    });
  }
  if (typeof model.paymentCapturableDate == "string")
    model.paymentCapturableDate = new Date(model.paymentCapturableDate);
  const transformDatespaymentReports =
    transformDatesMap.get("PaymentReportDTO");
  if (transformDatespaymentReports) {
    model.paymentReports?.forEach((sub) => {
      transformDatespaymentReports(sub);
    });
  }
});

export type PaymentReportsDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  paymentServiceChangeCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentCapturableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  paymentCapturableDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentReports: PropertyMeta<PaymentReportDTOMetaI>;
}>;

export var PaymentReportsDTOMeta: PaymentReportsDTOMetaI =
  {} as PaymentReportsDTOMetaI;
PaymentReportsDTOMeta = typeMeta("PaymentReportsDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
  childReports: propertyMeta("childReports", true, false, false, ReportDTOMeta),
  meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
  typeCounts: propertyMeta(
    "typeCounts",
    true,
    false,
    false,
    ReportTypeCountDTOMeta,
  ),
  paymentServiceChangeCents: propertyMeta(
    "paymentServiceChangeCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableCents: propertyMeta(
    "paymentCapturableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableDate: propertyMeta(
    "paymentCapturableDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentPaidCents: propertyMeta(
    "paymentPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentTotalCents: propertyMeta(
    "paymentTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentRefundedCents: propertyMeta(
    "paymentRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentToRefundCents: propertyMeta(
    "paymentToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentReports: propertyMeta(
    "paymentReports",
    true,
    true,
    false,
    PaymentReportDTOMeta,
  ),
});

const metaI = PaymentReportsDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ReportDTOMeta]);
  metaI.isDeleted.inheritedFrom = ReportDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = ReportDTOMeta.isNew;
  metaI.reportId.inheritedFrom = ReportDTOMeta.reportId;
  metaI.reportKey.inheritedFrom = ReportDTOMeta.reportKey;
  metaI.reportTitle.inheritedFrom = ReportDTOMeta.reportTitle;
  metaI.reportType.inheritedFrom = ReportDTOMeta.reportType;
  metaI.reportStatus.inheritedFrom = ReportDTOMeta.reportStatus;
  metaI.childReports.inheritedFrom = ReportDTOMeta.childReports;
  metaI.meta.inheritedFrom = ReportDTOMeta.meta;
  metaI.typeCounts.inheritedFrom = ReportDTOMeta.typeCounts;
  metaI.interfaces = metaI.interfaces.concat([OrderPaymentForReportMeta]);
  metaI.paymentServiceChangeCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentServiceChangeCents;
  metaI.paymentCapturableCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentCapturableCents;
  metaI.paymentCapturableDate.inheritedFrom =
    OrderPaymentForReportMeta.paymentCapturableDate;
  metaI.paymentPaidCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentPaidCents;
  metaI.paymentTotalCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentTotalCents;
  metaI.paymentRefundedCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentRefundedCents;
  metaI.paymentToRefundCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentToRefundCents;
});

export class PaymentReportsDTOTracked
  extends OrderPaymentForReportTracked
  implements PaymentReportsDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  paymentServiceChangeCents__I?: number = undefined;
  paymentServiceChangeCentsIsSet: boolean = false;
  set paymentServiceChangeCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentServiceChangeCents__I = v;
      this.paymentServiceChangeCentsIsSet = true;
    } else {
      this.paymentServiceChangeCents__I = v || undefined;
      this.paymentServiceChangeCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentServiceChangeCents() {
    return this.paymentServiceChangeCents__I;
  }
  paymentCapturableCents__I?: number = undefined;
  paymentCapturableCentsIsSet: boolean = false;
  set paymentCapturableCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentCapturableCents__I = v;
      this.paymentCapturableCentsIsSet = true;
    } else {
      this.paymentCapturableCents__I = v || undefined;
      this.paymentCapturableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableCents() {
    return this.paymentCapturableCents__I;
  }
  paymentCapturableDate__I?: Date = undefined;
  paymentCapturableDateIsSet: boolean = false;
  set paymentCapturableDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentCapturableDate__I = v;
      this.paymentCapturableDateIsSet = true;
    } else {
      this.paymentCapturableDate__I = v || undefined;
      this.paymentCapturableDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableDate() {
    return this.paymentCapturableDate__I;
  }
  paymentPaidCents__I?: number = undefined;
  paymentPaidCentsIsSet: boolean = false;
  set paymentPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentPaidCents__I = v;
      this.paymentPaidCentsIsSet = true;
    } else {
      this.paymentPaidCents__I = v || undefined;
      this.paymentPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentPaidCents() {
    return this.paymentPaidCents__I;
  }
  paymentTotalCents__I?: number = undefined;
  paymentTotalCentsIsSet: boolean = false;
  set paymentTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentTotalCents__I = v;
      this.paymentTotalCentsIsSet = true;
    } else {
      this.paymentTotalCents__I = v || undefined;
      this.paymentTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentTotalCents() {
    return this.paymentTotalCents__I;
  }
  paymentRefundedCents__I?: number = undefined;
  paymentRefundedCentsIsSet: boolean = false;
  set paymentRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentRefundedCents__I = v;
      this.paymentRefundedCentsIsSet = true;
    } else {
      this.paymentRefundedCents__I = v || undefined;
      this.paymentRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentRefundedCents() {
    return this.paymentRefundedCents__I;
  }
  paymentToRefundCents__I?: number = undefined;
  paymentToRefundCentsIsSet: boolean = false;
  set paymentToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentToRefundCents__I = v;
      this.paymentToRefundCentsIsSet = true;
    } else {
      this.paymentToRefundCents__I = v || undefined;
      this.paymentToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentToRefundCents() {
    return this.paymentToRefundCents__I;
  }
  paymentReports__I?: PaymentReportDTOTracked[] = undefined;
  paymentReportsIsSet: boolean = false;
  set paymentReports(v: undefined | PaymentReportDTOTracked[]) {
    if (v !== undefined) {
      this.paymentReports__I = v;
      this.paymentReportsIsSet = true;
    } else {
      this.paymentReports__I = v || undefined;
      this.paymentReportsIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentReports() {
    return this.paymentReports__I;
  }
  constructor(config?: PaymentReportsDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());

    this.paymentReports?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: PaymentReportsDTOOptional,
    options?: AssignOptions,
  ): PaymentReportsDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (
      config.paymentServiceChangeCents &&
      this.paymentServiceChangeCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentServiceChangeCents = config.paymentServiceChangeCents;
      if (optionsRequired.unassign) this.paymentServiceChangeCentsIsSet = false;
      else this.paymentServiceChangeCentsIsSet = true;
    }
    if (
      config.paymentCapturableCents &&
      this.paymentCapturableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableCents = config.paymentCapturableCents;
      if (optionsRequired.unassign) this.paymentCapturableCentsIsSet = false;
      else this.paymentCapturableCentsIsSet = true;
    }
    if (
      config.paymentCapturableDate &&
      this.paymentCapturableDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableDate = config.paymentCapturableDate;
      if (optionsRequired.unassign) this.paymentCapturableDateIsSet = false;
      else this.paymentCapturableDateIsSet = true;
    }
    if (
      config.paymentPaidCents &&
      this.paymentPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentPaidCents = config.paymentPaidCents;
      if (optionsRequired.unassign) this.paymentPaidCentsIsSet = false;
      else this.paymentPaidCentsIsSet = true;
    }
    if (
      config.paymentTotalCents &&
      this.paymentTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentTotalCents = config.paymentTotalCents;
      if (optionsRequired.unassign) this.paymentTotalCentsIsSet = false;
      else this.paymentTotalCentsIsSet = true;
    }
    if (
      config.paymentRefundedCents &&
      this.paymentRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentRefundedCents = config.paymentRefundedCents;
      if (optionsRequired.unassign) this.paymentRefundedCentsIsSet = false;
      else this.paymentRefundedCentsIsSet = true;
    }
    if (
      config.paymentToRefundCents &&
      this.paymentToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentToRefundCents = config.paymentToRefundCents;
      if (optionsRequired.unassign) this.paymentToRefundCentsIsSet = false;
      else this.paymentToRefundCentsIsSet = true;
    }
    if (
      config.paymentReports &&
      this.paymentReportsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentReports = config.paymentReports?.map(
        (a) => new PaymentReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.paymentReportsIsSet = false;
      else this.paymentReportsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PaymentReportsDTOTrackedI {
    const cloned = {} as PaymentReportsDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (
      this.paymentServiceChangeCentsIsSetDeep() &&
      this.paymentServiceChangeCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentServiceChangeCentsIsSet = true;
      cloned.paymentServiceChangeCents = this.paymentServiceChangeCents;
    } else {
      //cloned.paymentServiceChangeCentsIsSet = false
    }
    if (
      this.paymentCapturableCentsIsSetDeep() &&
      this.paymentCapturableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableCentsIsSet = true;
      cloned.paymentCapturableCents = this.paymentCapturableCents;
    } else {
      //cloned.paymentCapturableCentsIsSet = false
    }
    if (
      this.paymentCapturableDateIsSetDeep() &&
      this.paymentCapturableDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableDateIsSet = true;
      cloned.paymentCapturableDate = this.paymentCapturableDate;
    } else {
      //cloned.paymentCapturableDateIsSet = false
    }
    if (
      this.paymentPaidCentsIsSetDeep() &&
      this.paymentPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentPaidCentsIsSet = true;
      cloned.paymentPaidCents = this.paymentPaidCents;
    } else {
      //cloned.paymentPaidCentsIsSet = false
    }
    if (
      this.paymentTotalCentsIsSetDeep() &&
      this.paymentTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTotalCentsIsSet = true;
      cloned.paymentTotalCents = this.paymentTotalCents;
    } else {
      //cloned.paymentTotalCentsIsSet = false
    }
    if (
      this.paymentRefundedCentsIsSetDeep() &&
      this.paymentRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentRefundedCentsIsSet = true;
      cloned.paymentRefundedCents = this.paymentRefundedCents;
    } else {
      //cloned.paymentRefundedCentsIsSet = false
    }
    if (
      this.paymentToRefundCentsIsSetDeep() &&
      this.paymentToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentToRefundCentsIsSet = true;
      cloned.paymentToRefundCents = this.paymentToRefundCents;
    } else {
      //cloned.paymentToRefundCentsIsSet = false
    }
    if (
      this.paymentReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.paymentReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentReportsIsSet = true;
      cloned.paymentReports = this.paymentReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.paymentReportsIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PaymentReportsDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    if (!this.paymentServiceChangeCentsApplyFilter(filter))
      this.paymentServiceChangeCentsIsSet = false;

    if (!this.paymentCapturableCentsApplyFilter(filter))
      this.paymentCapturableCentsIsSet = false;

    if (!this.paymentCapturableDateApplyFilter(filter))
      this.paymentCapturableDateIsSet = false;

    if (!this.paymentPaidCentsApplyFilter(filter))
      this.paymentPaidCentsIsSet = false;

    if (!this.paymentTotalCentsApplyFilter(filter))
      this.paymentTotalCentsIsSet = false;

    if (!this.paymentRefundedCentsApplyFilter(filter))
      this.paymentRefundedCentsIsSet = false;

    if (!this.paymentToRefundCentsApplyFilter(filter))
      this.paymentToRefundCentsIsSet = false;

    if (!this.paymentReportsApplyFilter(filter))
      this.paymentReportsIsSet = false;

    this.paymentReports?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.isDeleted,
      PaymentReportsDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.isNew,
      PaymentReportsDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.reportId,
      PaymentReportsDTOMeta,
      this.reportId,
      this,
    );
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.reportKey,
      PaymentReportsDTOMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.reportTitle,
      PaymentReportsDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.reportType,
      PaymentReportsDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.reportStatus,
      PaymentReportsDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.childReports,
      PaymentReportsDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.meta,
      PaymentReportsDTOMeta,
      this.meta,
      this,
    );
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.typeCounts,
      PaymentReportsDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  paymentServiceChangeCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.paymentServiceChangeCents,
      PaymentReportsDTOMeta,
      this.paymentServiceChangeCents,
      this,
    );
  }
  paymentServiceChangeCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentServiceChangeCentsIsSet &&
      this.paymentServiceChangeCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.paymentCapturableCents,
      PaymentReportsDTOMeta,
      this.paymentCapturableCents,
      this,
    );
  }
  paymentCapturableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableCentsIsSet &&
      this.paymentCapturableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.paymentCapturableDate,
      PaymentReportsDTOMeta,
      this.paymentCapturableDate,
      this,
    );
  }
  paymentCapturableDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableDateIsSet &&
      this.paymentCapturableDateApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.paymentPaidCents,
      PaymentReportsDTOMeta,
      this.paymentPaidCents,
      this,
    );
  }
  paymentPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentPaidCentsIsSet && this.paymentPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  paymentTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.paymentTotalCents,
      PaymentReportsDTOMeta,
      this.paymentTotalCents,
      this,
    );
  }
  paymentTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentTotalCentsIsSet &&
      this.paymentTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.paymentRefundedCents,
      PaymentReportsDTOMeta,
      this.paymentRefundedCents,
      this,
    );
  }
  paymentRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentRefundedCentsIsSet &&
      this.paymentRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.paymentToRefundCents,
      PaymentReportsDTOMeta,
      this.paymentToRefundCents,
      this,
    );
  }
  paymentToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentToRefundCentsIsSet &&
      this.paymentToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportsDTOMeta.paymentReports,
      PaymentReportsDTOMeta,
      this.paymentReports,
      this,
    );
  }
  paymentReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentReportsIsSet && this.paymentReportsApplyFilter(filter))
      return true;

    return this.paymentReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    if (this.paymentServiceChangeCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableDateIsSetDeep(filter)) return true;
    if (this.paymentPaidCentsIsSetDeep(filter)) return true;
    if (this.paymentTotalCentsIsSetDeep(filter)) return true;
    if (this.paymentRefundedCentsIsSetDeep(filter)) return true;
    if (this.paymentToRefundCentsIsSetDeep(filter)) return true;
    if (this.paymentReportsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
